export default function(rawValue: string): boolean {
    // should contain ":" and at least one characher after it
    const value = rawValue.trim()
    const separatorIndex = value.indexOf(":")
    return separatorIndex > -1 && value.length > separatorIndex + 1
}
